module.exports = __webpack_public_path__ + "img/tipimg_x.00b832a8.png";